export const navigation = {
  dashboard: "Dashboard",
  providerStatus: "Provider Status",
  players: "Players",
  gameRounds: "Game Rounds",
  otpList: "OTP List",
  tierConfig: "Tier Config",
  playertier: "Tier",
  finance: "FINANCE",
  financeV2: "FINANCE V2",
  financeV1: "FINANCE V1",
  liveTransaction: "Live Transaction",
  depositTransaction: "Deposit Transaction",
  depositTransactionV2: "Deposit Transaction V2",
  withdrawTransaction: "Withdraw Transaction",
  withdrawTransactionV2: "Withdraw Transaction V2",
  withdrawTransactionV1: "Withdraw Transaction V1",
  manualDeposit: "Manual Deposit",
  manualWithdraw: "Manual Withdraw",
  manualDepositV1: "Manual Deposit V1",
  manualWithdrawV1: "Manual Withdraw V1",
  approveTopup: "Approve Topup",
  approveTopupV2: "Approve Topup V2",
  approveTopupV1: "Approve Topup V1",
  approvePayout: "Approve Payout",
  approvePayoutV2: "Approve Payout V2",
  approvePayoutV1: "Approve Payout V1",
  affiliateCommission: "AFFILIATE & COMMISSION",
  newMember: "New Member",
  affiliateSummaryCarryForward: "Affiliate Summary Carry Forward",
  affiliateSummary: "Affiliate Summary",
  nonAffiliateSummary: "Non-Affiliate Summary",
  affiliatePayout: "Affiliate Payout",
  commissionSummary: "Commission Summary",
  commissionPayout: "Commission Payout",
  loyaltySettings: "LOYALTY SETTINGS",
  loyaltyConfig: "Loyalty Config",
  rewardCategory: "Reward Category",
  reward: "Reward",
  loyalty: "LOYALTY",
  loyaltyInfo: "Loyalty Info",
  rewardRedemption: "Reward Redemption",
  pointRequest: "Point Request",
  pointRequestHistory: "Point Request History",
  websiteSettings: "WEBSITE SETTINGS",
  banner: "Banner",
  userInformation: "USER INFORMATION",
  userActivityLogs: "User Activity Logs",
  adminActivityLogs: "Admin Activity Logs",
  adminActivityLogs2: "Admin Activity Logs 2",
  usernameUpdateRequests: "Username Update Request",
  usernameUpdateHistory: "Username Update History",
  report: "Report",
  dailyReport: "Daily Report",
  gameReport: "Game Report",
  playerReport: "Player Report",
  summaryReport: "Summary Report",
  paymentDailyReport: "Payment Daily Report",
  gameRanking: "Game Ranking",
  event: "Event",
  eventReward: "Event Reward",
  eventSetting: "EVENT SETTING",
  userEvent: "User Event",
  blacklistedUsers: "Blacklisted Users",
  reconciledMembers: "Reconciled New Members",
  approveMessage: "Approve Message",
  realtimeDashboard: "Realtime (BETA)",
  ticketManager: "บริหารจัดการคำขอต่างๆ",
  paymentConfig: "Payment Config",
  paymentConfigV2: "Payment Config V2",
  payment: "Payment",
  fortuneWheelConfig:"Fortune Wheel Config",
  activityLogs: "Activity Logs",
  stream:"Stream",
  streamer:"Streamer",
  streaming:"Streaming",
  streamConfig:"Stream Config",
  bankVerifyConfig:"Bank Verify Config",
  paymentWithdrawTierConfig:"Payment Withdraw Tier Config",
  paymentMultipleDepositConfig:"Payment Multiple Deposit Config",
  paymentTierConfig:"Payment Tier Config",
  paymentDepositTieringConfig:"Payment Deposit Tiering Config",
  "autoWithdrawList": "Auto Withdraw List (V3)",
  "autoDepositList": "Auto Deposit List (V3)",
  depositConfig: "Deposit Config (V3)",
  withdrawConfig: "Withdraw Config (V3)",
  commission: "Commission",
  internalDeposit: "Internal Deposit",
  assignUserTopup: "Assigning User Topup",
  assignOperatorTopup: "Assigning Operator Topup",
  coupon: 'Coupon',
  couponCondition: 'Coupon Condition',
  paymentApprovalReport: 'Payment Approval Report',
};
